import { getAllocationUtils } from './utils';
import sortByPrice from './sortByPrice';
import promotedVideoStrip from './promotedVideoStrip';
import { agenciesInListingsGD } from './agenciesInListingsGD';
import { hourlyBannerGuest, hourlyBannerUser } from './hourlyBannerUserAndGuest';

const experiments = {
    sortByPrice,
    promotedVideoStrip,
    agenciesInListingsGD,
    hourlyBannerGuest,
    hourlyBannerUser,
};

export const clientExperiments = getAllocationUtils(experiments);
